import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'truckit_business_fe';
  isCollapsed = true;

  constructor(public router: Router){}

  public hiddenSidebarUrls: string[] = [
    '/view/proof-of-delivery/',
    '/access-denied',
  ];

  // URLs for which the header should be hidden
  public hiddenHeaderUrls: string[] = [
    '/view/proof-of-delivery/',
    '/access-denied',
  ];

  // Determine if the header should be hidden based on the current URL
  public isHeaderHidden(): boolean {
    return this.hiddenHeaderUrls.some(prefix => this.router.url.startsWith(prefix));
  }

  public isSidebarHidden(): boolean {
    return this.hiddenSidebarUrls.some(prefix => this.router.url.startsWith(prefix));
  }

  public isFullWidthPage(): boolean {
    const fullWidthPrefixes = ['/broker-manager', '/listings-and-bookings'];
    return fullWidthPrefixes.some(prefix => this.router.url.startsWith(prefix));
  }

  toggleSidebar(collapsed: boolean) {
    this.isCollapsed = collapsed;
  }
}
